import { Injectable } from '@angular/core';
import { PocketGeekContent } from '@assurantlabs/content';
import { PreInitSettingsService } from '../../core/services/settings/pre-init-setting.service';

@Injectable({
  providedIn: 'root'
})
export class DeviceContentApiService {

  private api: PocketGeekContent.Api;

  public constructor(
    private preInitSettingsService: PreInitSettingsService,
  ) {
    this.api = PocketGeekContent.getInstance(this.preInitSettingsService.getSettings()?.deviceContentSdkApiKey);

    // TODO: move this to a Sitefinity setting some day when we need to support more than English.
    this.api.setPreferredLanguages(['en-US']);
  }

  public async getDeviceContent(device: PocketGeekContent.Device, contentCategories: PocketGeekContent.ContentItemCategory[]): Promise<PocketGeekContent.ContentItem[]> {
    return this.api.get(contentCategories).for(device);
  }
  public async requestDeviceContent(device: PocketGeekContent.Device, categories: PocketGeekContent.ContentRequestCategory[], comments?: string): Promise<PocketGeekContent.ContentRequest[]> {
    return this.api.request({categories, comments}).for(device);
  }
  public async sendDeviceContentFeedback(content: PocketGeekContent.ContentItem, sentiment: PocketGeekContent.Sentiment): Promise<PocketGeekContent.ContentItemFeedback> {
    return this.api.express(sentiment).toward(content);
  }
  public async addContentFeedback(contentItemFeedback: PocketGeekContent.ContentItemFeedback, categories: PocketGeekContent.ContentItemFeedbackCategory[], comments?: string): Promise<PocketGeekContent.ContentItemFeedback>{
    return this.api.add({categories, comments}).to(contentItemFeedback);
  }
  public async searchForDevices(searchQuery: string): Promise<PocketGeekContent.DeviceMetadata[]> {
    return this.api.searchDevices(searchQuery);
}

}
